import { render, staticRenderFns } from "./RationsTableRow.vue?vue&type=template&id=0ed64180&lang=pug"
import script from "./RationsTableRow.vue?vue&type=script&lang=js"
export * from "./RationsTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports